<template>
    <!--    微信分享引导弹窗-->
    <van-popup
        style="background: transparent"
        :value="value"
        :showConfirmButton="false"
        position="center"
        :overlay="true"
        :close-on-click-overlay="false">
        <div class="main">
            <div class="content">
                <div class="title">暖小加小程序</div>
                <div class="tip_one">扫描小程序，查看更多详情</div>
                <div class="qrcode">
                    <img class="qrcode_img" :src="qrCode" alt="">
                </div>
                <div class="tip_two">长按识别图中二维码</div>
            </div>
            <div class="closebox">
                <img @click="$emit('input', false)" src="./img/close.png" alt="">
            </div>
        </div>
    </van-popup>
</template>
<script>
    import {Popup as vanPopup} from 'vant'

    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            qrCode: String,
        },
        components: {vanPopup}
    }
</script>
<style lang="scss" scoped>
    .main {
        overflow: hidden;
        .content {
            width: 294px;
            height: 350px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            background-image: url('./img/program_bk.png');
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 27px;
            .title {
                font-size: 27px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                line-height: 30px;
                text-shadow: 0 1px 2px rgba(255, 114, 0, 0.44);
            }

            .tip_one {
                font-size: 17px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                text-shadow: 0 1px 2px rgba(255, 114, 0, 0.44);
                margin-top: 11px;
                margin-bottom: 20px;
            }
            .qrcode {
                width: 150px;
                background: #ffffff;
                border-radius: 8px;
                padding: 6px;
                box-sizing: border-box;

                &_img {
                    display: inline-block;
                    width: 100%;
                }
            }

            .tip_two {

                font-size: 17px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                text-shadow: 0 1px 2px rgba(255, 114, 0, 0.44);
                margin-bottom: 30px;
                margin-top: 17px;
            }
        }
        .closebox {

            text-align: center;
            img {
                display: inline-block;
                width: 36px;
            }
        }

    }

</style>
